module.exports = __webpack_public_path__ + "img/kebap-background-2.cdb152d9.jpg";